import { defineRoute } from '../defineRoute';

export type MySettingsRouteParams = {
  // ...
};

export type MySettingsRouteParamsString = {
  // ...
};

export const MySettings = defineRoute<
  MySettingsRouteParams,
  MySettingsRouteParamsString
>({
  pathname: '/account/settings',
  nlPathname: '/account/instellingen',
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
